module.exports = __webpack_public_path__ + "static/media/HX.fe676af1.png";